import { positionsInTheCompanyEnum } from "@dune/types";
import { brokerContactCreationSubRoles } from "@dune/vars";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export const addUserSchema = z
	.object({
		entity: z.string().optional(),
		lastname: z.string().min(1, "Le nom est requis"),
		firstname: z.string().min(1, "Le prénom est requis"),
		email: z.email("Email invalide"),
		mobilePhone: z
			.string()
			.transform((val) => (val === "" ? undefined : val))
			.optional()
			.refine((val) => val === undefined || /^[+]?[\d\s()-]*$/.test(val), {
				message: "Numéro de téléphone mobile invalide",
			}),
		landlinePhone: z
			.string()
			.transform((val) => (val === "" ? undefined : val))
			.optional()
			.refine((val) => val === undefined || /^[+]?[\d\s()-]*$/.test(val), {
				message: "Numéro de téléphone fixe invalide",
			}),
		positionInTheCompany: z.enum(positionsInTheCompanyEnum, {
			error: "La fonction est requise",
		}),
		subrole: z.enum(brokerContactCreationSubRoles, {
			error: "Le sous-rôle est requis",
		}),
		isSignatory: z.boolean().optional(),
	})
	.superRefine((data, ctx) => {
		if (!data.mobilePhone && !data.landlinePhone) {
			ctx.addIssue({
				code: "custom",
				message: "Au moins un numéro de téléphone est requis",
				path: ["mobilePhone"],
			});
			ctx.addIssue({
				code: "custom",
				message: "Au moins un numéro de téléphone est requis",
				path: ["landlinePhone"],
			});
		}
	});

export type AddUserFormData = z.infer<typeof addUserSchema>;

const defaultValues: Partial<AddUserFormData> = {
	entity: "",
	lastname: "",
	firstname: "",
	email: "",
	mobilePhone: undefined,
	landlinePhone: undefined,
	isSignatory: false,
};

interface UseAddUserFormProps {
	initialValues?: Partial<AddUserFormData>;
}

export const useAddUserForm = ({ initialValues }: UseAddUserFormProps = {}) => {
	return useForm<AddUserFormData>({
		resolver: zodResolver(addUserSchema),
		defaultValues: {
			...defaultValues,
			...initialValues,
		},
	});
};
